import axios from "axios";

/**
 * Consulta los datos del tablero de soportes históricos
 * @param {Object} data - Datos de búsqueda
 * @returns {Promise<Array>} Lista de registros obtenidos
 */

export async function getOrdenEnd(data) {
  try {
    const response = await axios.get(
      "/ProcesosP/RelacionProcesoDato/GetOrderEnd?proceso=" + data,
    );
    return response.data;
  } catch (error) {
    // Lanzamos el error para manejarlo en el componente
    throw error.response ? error.response : error;
  }
}

export async function getRelacionProcesoDato(data) {
  try {
    const response = await axios.post(
      "/ProcesosP/RelacionProcesoDato/Get",
      data,
    );
    return response.data;
  } catch (error) {
    // Lanzamos el error para manejarlo en el componente
    throw error.response ? error.response : error;
  }
}

export async function upsertRelacionProcesoDato(data) {
  try {
    const response = await axios.post(
      "/ProcesosP/RelacionProcesoDato/Post",
      data,
    );
    return response.data;
  } catch (error) {
    // Lanzamos el error para manejarlo en el componente
    throw error.response ? error.response : error;
  }
}
